/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FindAllIcd10CodesResponse } from './FindAllIcd10CodesResponse';
import {
    FindAllIcd10CodesResponseFromJSON,
    FindAllIcd10CodesResponseFromJSONTyped,
    FindAllIcd10CodesResponseToJSON,
} from './FindAllIcd10CodesResponse';

/**
 * 
 * @export
 * @interface FindAllIcd10Codes200Response
 */
export interface FindAllIcd10Codes200Response {
    /**
     * 
     * @type {FindAllIcd10CodesResponse}
     * @memberof FindAllIcd10Codes200Response
     */
    data?: FindAllIcd10CodesResponse;
}

/**
 * Check if a given object implements the FindAllIcd10Codes200Response interface.
 */
export function instanceOfFindAllIcd10Codes200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FindAllIcd10Codes200ResponseFromJSON(json: any): FindAllIcd10Codes200Response {
    return FindAllIcd10Codes200ResponseFromJSONTyped(json, false);
}

export function FindAllIcd10Codes200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllIcd10Codes200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : FindAllIcd10CodesResponseFromJSON(json['data']),
    };
}

export function FindAllIcd10Codes200ResponseToJSON(value?: FindAllIcd10Codes200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': FindAllIcd10CodesResponseToJSON(value.data),
    };
}

